export const Geolocation = {
  requestPermissions: async () => ({
    location: 'denied',
    coarseLocation: 'denied'
  }),
  getCurrentPosition: async () => {
    throw new Error('Geolocation is only available in Capacitor builds')
  }
}
